"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dropdown_svg_1 = __importDefault(require("res/img/dropdown.svg"));
var Loading_1 = __importDefault(require("../../Loading"));
var utils_1 = require("../../../util/utils");
var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["BOTTOM"] = "bottom";
})(Position || (Position = {}));
var Select = function (_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, busy = _a.busy;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = react_1.useState(Position.BOTTOM), position = _c[0], setPosition = _c[1];
    var selectRef = react_1.useRef(null);
    var listRef = react_1.useRef(null);
    var selectKeyRef = react_1.useRef(utils_1.uuid());
    react_1.useEffect(function () {
        if (open) {
            document.addEventListener('keyup', keyHandler);
            document.addEventListener('click', clickHandler);
        }
        return function () {
            document.removeEventListener('click', clickHandler);
            document.removeEventListener('keyup', keyHandler);
        };
    }, [open]);
    var keyHandler = function (e) {
        if (e.key === 'Escape') {
            setOpen(false);
        }
    };
    var clickHandler = function (e) {
        var target = e.target;
        if (target.closest(".select[data-id=\"" + selectKeyRef.current + "\"]") === null &&
            target !== selectRef.current) {
            setOpen(false);
        }
    };
    var toggleOpen = function () {
        if (busy)
            return;
        var bounds = selectRef.current.getBoundingClientRect();
        var newPosition = Position.BOTTOM;
        if (bounds.bottom >= window.innerHeight - 300) {
            newPosition = Position.TOP;
        }
        setPosition(newPosition);
        setOpen(!open);
    };
    var changeHandler = function (value) {
        setOpen(false);
        onChange(value);
    };
    var getValueText = function () {
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            if (value === option.value || value && value.id && value.id === option.value.id)
                return option.text;
        }
    };
    react_1.useEffect(function () {
        if (open) {
            var listItemsLI = listRef.current.children;
            for (var i = 0; i < listItemsLI.length; i++) {
                var htmlElement = listItemsLI[i];
                if (htmlElement.getAttribute('aria-selected') === 'true') {
                    listRef.current.scrollTo({
                        left: 0,
                        top: htmlElement.offsetTop
                    });
                    break;
                }
            }
        }
    }, [open]);
    return (react_1.default.createElement("div", { className: 'select', ref: selectRef, "data-id": selectKeyRef.current, "aria-haspopup": true, "data-busy": busy, "data-open": open },
        react_1.default.createElement("div", { className: 'select__value', onClick: toggleOpen },
            react_1.default.createElement("span", null, value === null ? 'Please Select' : getValueText()),
            react_1.default.createElement("div", { className: 'select__value__dropdown flex flex-column flex-center' },
                react_1.default.createElement("img", { src: dropdown_svg_1.default, alt: 'Select' }))),
        react_1.default.createElement("ul", { className: 'select__list thin-scroll', "aria-hidden": !open, role: 'menu', ref: listRef, "data-position": position }, options.length > 0 ?
            options.map(function (option, index) { return (react_1.default.createElement("li", { key: index, role: 'menuitem', "data-disabled": option.disabled, "aria-selected": value === option.value || value && value.id && value.id === option.value.id, onClick: function () { return changeHandler(option.value); } }, option.text)); }) :
            react_1.default.createElement("li", { "data-disabled": true }, "No items available")),
        busy && react_1.default.createElement(Loading_1.default, null)));
};
exports.default = Select;
